import React from "react";

interface IconStarProps {
	fill?: boolean;
}

const IconStar: React.FC<IconStarProps> = ({ fill }) => {
	return (
		<svg
			viewBox="0 0 24 24"
			fill={fill ? "currentColor" : "none"}
			xmlns="http://www.w3.org/2000/svg"
			color="currentColor"
		>
			<path
				d="M8.587 8.236l2.598-5.232a.911.911 0 011.63 0l2.598 5.232 5.808.844a.902.902 0 01.503 1.542l-4.202 4.07.992 5.75c.127.738-.653 1.3-1.32.952L12 18.678l-5.195 2.716c-.666.349-1.446-.214-1.319-.953l.992-5.75-4.202-4.07a.902.902 0 01.503-1.54l5.808-.845z"
				stroke="currentColor"
				stroke-width="2.07"
				stroke-linecap="round"
				stroke-linejoin="round"
			></path>
		</svg>
	);
};

export default IconStar;
